import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useEffect, useState } from "react";
import { getWebinars } from "../actions/ApiCalls";
import {IMAGE_URL} from "../path";
import { useNavigate } from "react-router-dom";

const Webinars = () => {
    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    const navigate = useNavigate();
    const imgUrl = IMAGE_URL;

    const [webinars, setWebinars] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12; // Updated to match NewsStories

    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        isDesktop: window.innerWidth > 950,
        isTablet: window.innerWidth <= 950 && window.innerWidth > 575,
        isMobile: window.innerWidth <= 575,
    });

    useEffect(() => {
        getWebinars()
            .then(response => setWebinars(response.data))
            .catch(err => console.error("Failed to fetch webinars:", err));

        document.title = "Vinimark | Webinars";
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                width,
                isDesktop: width > 950,
                isTablet: width <= 950 && width > 575,
                isMobile: width <= 575,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [currentPage]);

    const totalPages = Math.ceil(webinars.length / itemsPerPage);
    const currentWebinars = webinars.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Header />

            {/* Hero Section */}
            <div style={{
                marginTop: '130px',
                display: 'flex',
                flexDirection: screenSize.isMobile ? 'column' : 'row',
                gap: '20px',
            }}>
                <div style={{ flex: 1 }}></div>
                <div style={{
                    flex: 1,
                    textAlign: 'left',
                    paddingRight: '20px',
                    paddingLeft: screenSize.isMobile ? '20px' : '50px',
                }}>
                    <p style={{ fontWeight: 600, textTransform: 'uppercase' }}>WEBINARS</p>
                    <p style={{
                        width: screenSize.isMobile ? '95%' : '60%',
                        marginBottom: '10px',
                        fontWeight: 400,
                    }}>
                        Vinimark’s webinars are where insight and innovation fuse together. These interactive sessions feature industry experts, winemakers, and thought leaders discussing the trends and opportunities shaping the wine world today.
                    </p>
                    <p style={{ fontSize: '13px', marginBottom: '100px' }}>
                        <a style={linkStyle} href="/subscribe">Join our mailing list</a>
                    </p>
                </div>
            </div>

            {/* Webinars Grid */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: screenSize.isDesktop
                    ? 'repeat(4, 1fr)'
                    : screenSize.isTablet
                        ? 'repeat(2, 1fr)'
                        : '1fr',
                gap: screenSize.isMobile ? '35px' : '50px',
                padding: screenSize.isMobile
                    ? '0 20px'
                    : screenSize.isTablet
                        ? '0 30px'
                        : '0 50px',
                marginBottom: '50px',
            }}>
                {currentWebinars.map((webinar, index) => (
                    <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{
                            width: '100%',
                            aspectRatio: '1/1',
                            overflow: 'hidden',
                            marginBottom: '20px',
                        }}>
                            <img
                                src={imgUrl + webinar.image}
                                alt={webinar.title}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </div>

                        <div style={{ textAlign: 'left' }}>
                            <p style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                            }}>
                                {webinar.title}
                            </p>
                            <p style={{
                                fontSize: '10px',
                                fontWeight: 600,
                                marginBottom: '12px',
                            }}>
                                {new Date(webinar.created_at).toISOString().split("T")[0]}
                            </p>
                            <div style={{
                                marginBottom: '15px',
                                fontWeight: 400,
                                fontSize: '12px',
                            }}>
                                {webinar.subtitle}
                            </div>
                            <a
                                style={linkStyle}
                                onClick={() => navigate(`/webinars/${webinar.search_name}`)}
                            >
                                Read more
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            {/* Newsletter CTA */}
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <a
                    style={{
                        ...linkStyle,
                        display: 'block',
                        width: '100%',
                        textAlign: 'center',
                        paddingTop: '50px',
                        paddingBottom: '30px',
                    }}
                    href="/subscribe"
                >
                    Join our newsletter
                </a>
            </div>

            {/* Pagination */}
            <div style={{ textAlign: 'center', marginBottom: '50px', gap: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ minWidth: '100px', textAlign: 'center' }}>Previous</button>
                <span style={{ minWidth: '100px', textAlign: 'center' }}>Page {currentPage} of {totalPages}</span>
                <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={{ minWidth: '100px', textAlign: 'center' }}>Next</button>
            </div>

            <Footer />
        </div>
    );
};

export default Webinars;
